// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer-module__footerContainer___aqR0t","copyrights":"Footer-module__copyrights___qTY6s"};